function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext } from 'react';
import { useStoreId, useConfigService } from '@thd-nucleus/experience-context';
import { useDataModel, QueryContext } from '@thd-nucleus/data-sources';
const ruleMap = {
  QuestionsAndAnswersAccordionTitle: {
    expectedValue: true
  },
  RatingsAndReviewsAccordionTitle: {
    expectedValue: true
  }
};
const COMBO_EXPERIENCE_FEATURES = {
  questionsAndAnswers: true,
  ratingsAndReview: true
};
const LAUNDRY_EXPERIENCE_FEATURES = {
  questionsAndAnswers: false,
  ratingsAndReview: false
};
const KITCHEN_EXPERIENCE_FEATURES = {
  questionsAndAnswers: false,
  ratingsAndReview: false
};
const feature = {
  default: COMBO_EXPERIENCE_FEATURES,
  laundry: LAUNDRY_EXPERIENCE_FEATURES,
  kitchen: KITCHEN_EXPERIENCE_FEATURES
};
export function withDynamicBundleAccordion(BaseComponent) {
  let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  function DynamicBundleAccordionRule(props) {
    var _defaultVariables$cur, _productData$product, _productData$product$;
    const {
      renderRules: renderRulesProp = [],
      propRules: propRulesProp = {},
      componentDisplayName: _componentDisplayName,
      itemId
    } = props;
    const {
      defaultVariables
    } = useContext(QueryContext) || {};
    const storeId = useStoreId();
    const isCustomerIdentified = (defaultVariables === null || defaultVariables === void 0 ? void 0 : (_defaultVariables$cur = defaultVariables.current) === null || _defaultVariables$cur === void 0 ? void 0 : _defaultVariables$cur.isBrandPricingPolicyCompliant) || false;
    const {
      data: productData
    } = useDataModel('product', {
      variables: {
        itemId,
        storeId,
        isBrandPricingPolicyCompliant: isCustomerIdentified
      },
      skip: !itemId
    });
    const configExperienceType = useConfigService('bundle-experience');
    const experienceType = configExperienceType || (productData === null || productData === void 0 ? void 0 : (_productData$product = productData.product) === null || _productData$product === void 0 ? void 0 : (_productData$product$ = _productData$product.bundleSpecificationDetails) === null || _productData$product$ === void 0 ? void 0 : _productData$product$.experienceType);
    const bundleExperienceFeatures = feature[experienceType] || feature.default;
    const {
      questionsAndAnswers: QuestionsAndAnswersAccordionTitle,
      ratingsAndReview: RatingsAndReviewsAccordionTitle
    } = bundleExperienceFeatures || {};
    const values = {
      QuestionsAndAnswersAccordionTitle,
      RatingsAndReviewsAccordionTitle
    };
    const renderRules = [...renderRulesProp];
    const propRules = _objectSpread({}, propRulesProp);
    const processRender = render => {
      const mappedRule = ruleMap[render.name];
      if (render.name === _componentDisplayName && mappedRule) {
        const matchedValue = values[render.name] === mappedRule.expectedValue;
        renderRules.push(render.negate ? !matchedValue : matchedValue);
      }
    };
    if (opts.render) {
      if (Array.isArray(opts.render)) {
        opts.render.forEach(processRender);
      } else {
        processRender(opts.render);
      }
    }
    return /*#__PURE__*/React.createElement(BaseComponent, _extends({}, props, {
      renderRules: renderRules,
      propRules: propRules
    }));
  }
  DynamicBundleAccordionRule.displayName = 'DynamicBundleAccordionRule';
  DynamicBundleAccordionRule.dataModel = {};
  return DynamicBundleAccordionRule;
}
//# sourceMappingURL=withDynamicBundleAccordion.js.map